export default "__VITE_ASSET__10cdb9fb__"